import { FC, useMemo } from 'react';
import Stack from '@mui/material/Stack';
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import TelegramIcon from '@mui/icons-material/Telegram';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import TwitterIcon from '@mui/icons-material/Twitter';
import Link from '@mui/material/Link';

import useBranding from 'store/branding';

const SocialBox: FC = () => {
  const [brandingState] = useBranding();
  const hasSocial = useMemo(() => {
    return (
      !!brandingState.settings.socialFacebook ||
      !!brandingState.settings.socialInstagram ||
      !!brandingState.settings.socialTelegram ||
      !!brandingState.settings.socialWhatsapp ||
      !!brandingState.settings.socialX ||
      !!brandingState.settings.socialYoutube
    );
  }, [brandingState.settings]);

  return !hasSocial ? null : (
    <Stack direction="row" spacing={2} justifyContent="center" alignItems="center" flexWrap="wrap">
      {brandingState.settings.socialFacebook && (
        <Link
          href={brandingState.settings.socialFacebook}
          target="new"
          sx={{ lineHeight: 1, color: 'custom.socialMedia.fb' }}
        >
          <FacebookOutlinedIcon />
        </Link>
      )}
      {brandingState.settings.socialYoutube && (
        <Link
          href={brandingState.settings.socialYoutube}
          target="new"
          sx={{ lineHeight: 1, color: 'custom.socialMedia.youtube' }}
        >
          <YouTubeIcon />
        </Link>
      )}
      {brandingState.settings.socialInstagram && (
        <Link
          href={brandingState.settings.socialInstagram}
          target="new"
          sx={{ lineHeight: 1, color: 'custom.socialMedia.instagram' }}
        >
          <InstagramIcon />
        </Link>
      )}
      {brandingState.settings.socialWhatsapp && (
        <Link
          href={brandingState.settings.socialWhatsapp}
          target="new"
          sx={{ lineHeight: 1, color: 'custom.socialMedia.whatsapp' }}
        >
          <WhatsAppIcon />
        </Link>
      )}
      {brandingState.settings.socialTelegram && (
        <Link
          href={brandingState.settings.socialTelegram}
          target="new"
          sx={{ lineHeight: 1, color: 'custom.socialMedia.telegram' }}
        >
          <TelegramIcon />
        </Link>
      )}
      {brandingState.settings.socialX && (
        <Link
          href={brandingState.settings.socialX}
          target="new"
          sx={{ lineHeight: 1, color: 'custom.socialMedia.twitter' }}
        >
          <TwitterIcon />
        </Link>
      )}
    </Stack>
  );
};

export default SocialBox;
